import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bc6a4db2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc6a4db2')) {
      api.createRecord('bc6a4db2', component.options)
    } else {
      api.reload('bc6a4db2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bc6a4db2&", function () {
      api.rerender('bc6a4db2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/attractManage/analyticStatistics/index.vue"
export default component.exports